import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from '../../../environments/environment';

export const authConfig: AuthConfig = {
  issuer: environment.oidc.issuer,
  redirectUri: `${window.location.origin}/auth/callback`,
  clientId: environment.oidc.clientId,
  logoutUrl: `${environment.oidc.issuer}/logout`,
  postLogoutRedirectUri: window.location.origin,
  responseType: 'code',
  sessionChecksEnabled: false,
  scope: 'openid profile email params',
  showDebugInformation: false,
  resource: 'http://localhost:4410',
};
